"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./mutable-buffer"), exports);
const mutable_buffer_1 = require("./mutable-buffer");
function default_1(size, blockSize) {
    return new mutable_buffer_1.MutableBuffer(size, blockSize);
}
exports.default = default_1;
//# sourceMappingURL=index.js.map